"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Instance = exports.ContentType = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const FieldDef_1 = require("./FieldDef");
const Base_1 = require("./Base");
const Utilities_1 = require("../javascript/Utilities");
var ContentType;
(function (ContentType) {
    ContentType[ContentType["Normal"] = 1] = "Normal";
    ContentType[ContentType["Convert"] = 2] = "Convert";
    ContentType[ContentType["Binary"] = 4] = "Binary";
    ContentType[ContentType["OrgTemplate"] = 8] = "OrgTemplate";
    ContentType[ContentType["Preview"] = 16] = "Preview";
    ContentType[ContentType["Print"] = 32] = "Print";
    ContentType[ContentType["Icon"] = 64] = "Icon";
    ContentType[ContentType["JPreview"] = 128] = "JPreview";
    ContentType[ContentType["BinarySup"] = 256] = "BinarySup";
    ContentType[ContentType["JIcon"] = 512] = "JIcon";
    ContentType[ContentType["FrontPage"] = 1024] = "FrontPage";
    ContentType[ContentType["Workflow"] = 2048] = "Workflow";
    ContentType[ContentType["JThumbnail"] = 4096] = "JThumbnail";
    ContentType[ContentType["FreeText"] = 16384] = "FreeText";
    ContentType[ContentType["RedLine"] = 16384] = "RedLine";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class Instance extends kendo.data.ObservableObject {
    // Methods
    constructor(instance) {
        super();
        this._itemsComplete = true;
        this._ftEntriesAvailable = false;
        this._contentsAvailable = false;
        // Properties
        /**
        *  Beinhaltet alle Felder der Instance
        */
        this.items = {};
        /**
        *  Interne id der Instanz
        */
        this.id = new Instance.Field();
        /**
        *  name der Instance, der dem Benutzer angezeigt werden kann
        */
        this.name = new Instance.Field();
        /**
        *  name der Instance, der dem Benutzer in der Strukturansicht (=Tree) angezeigt werden soll.
        */
        this.treename = new Instance.Field();
        /**
        *  icon der Instance
        */
        this.icon = new Instance.Field();
        /**
        *  Kommentar zur Instance.
        */
        this.comment = new Instance.Field();
        /**
        *  Informationen bezüglich der FTEntries, die in dieser Instance referenziert werden.
        *  z.B., ob ein Entry hard- oder softdeleted ist.
        *  ftEntries steht nur zur Verfügung, wenn vom Server die Informationen geliefert wurden.
        *  Ob ftEntries gefüllt ist, kann mittels des Properties ftEntriesAvailable bestimmt werden.
        *  ACHTUNG: die Daten in ftEntries dürfen NICHT modifiziert werden, da in clone diese Daten nicht "geklont" werden!
        */
        this.ftEntries = {};
        /**
        *  Beinhaltet die Metadaten zu den einzelnen Contents.
        *  Ob die contents vom Server geladen wurden, kann mittels des Properties contentsAvailable bestimmt werden.
        */
        this.contents = [];
        /**
        *  Am Server werden - außer bei searchExpression=true - in Instance nicht vorhandene Items mit Leerwerten aufgefüllt.
        *  Das kann mittels dieses Properties unterdrückt werden.
        *  =true: Nicht vorhandene items werden am Server NICHT mit Leerwerten aufgefüllt.
        *  =false (=Default): Nicht vorhandene items werden am Server mit Leerwerten aufgefüllt.
        */
        this.skipAddEmptyFields = false;
        if (instance) {
            for (let key in instance.items) {
                this.items[key] = new Instance.Field(instance.items[key]);
            }
            this.id = new Instance.Field(instance.id);
            this.name = new Instance.Field(instance.name);
            this.treename = new Instance.Field(instance.treename);
            this.icon = new Instance.Field(instance.icon);
            this.comment = new Instance.Field(instance.comment);
            this.ftEntries = instance.ftEntries; // Hier genügt es derzeit die Referenz zu kopieren, da diese Daten nicht verändert werden (dürfen)
            this._itemsComplete = instance._itemsComplete;
            this._itemsIncluded = instance._itemsIncluded; // Hier genügt es derzeit die Referenz zu kopieren, da diese Daten nicht verändert werden (dürfen)
            this._ftEntriesAvailable = instance._ftEntriesAvailable;
            this._contentsAvailable = instance._contentsAvailable;
            for (let content of instance.contents) {
                this.contents.push(content.clone());
            }
        }
    }
    addField(key, value, fieldDef, searchExpression) {
        let field = this.items[key];
        if (!field) {
            field = new Instance.Field();
            this.items[key] = field;
        }
        field.fieldDef = fieldDef;
        field.searchExpression = searchExpression;
        field.value = value;
        return field;
    }
    addFieldNoCheck(key, value, fieldDef, searchExpression) {
        let field = this.items[key];
        if (!field) {
            field = new Instance.Field();
            this.items[key] = field;
        }
        field.fieldDef = fieldDef;
        field.searchExpression = searchExpression;
        field._valueInternal = value; // Hier wird auf private Member zugegriffen, um die Typechecks zu umgehen.
        return field;
    }
    addEmptyField(key, fieldDef, searchExpression) {
        let field = this.items[key];
        if (!field) {
            field = new Instance.Field();
            this.items[key] = field;
        }
        field.fieldDef = fieldDef;
        field.searchExpression = searchExpression;
        field.clear();
        return field;
    }
    /**
     *  =true: es wurden alle items vom Server geholt.
     *  =false: es wurden nur einige items vom Server geholt. Die Instance ist nicht vollständig
    */
    get itemsComplete() {
        return this._itemsComplete;
    }
    ;
    /**
     *  =undefined: es wurden alle items vom Server geholt.
     *  !=undefined: die items mit diesen keys wurden vom Server angefordert
    */
    get itemsIncluded() {
        return this._itemsIncluded;
    }
    ;
    /**
     *  =true: es wurden auch die in den values referenzierten FTEntry-Infos vom Server geholt.
     *  =false: die in den values referenzierten FTEntry-Infos wurden vom Server nicht geholt und stehen somit auch nicht zur Verfügung.
    */
    get ftEntriesAvailable() {
        return this._ftEntriesAvailable;
    }
    /**
    *  =true: Content-Metadaten (=property contents) wurden vom Server geholt.
    *  =false: Content-Metadaten (=property contents) wurden vom Server nicht geholt und stehen somit auch nicht zur Verfügung.
    */
    get contentsAvailable() {
        return this._contentsAvailable;
    }
    /**
    *  Nimmt ein deepcopy der Instance vor
    */
    clone() {
        return new Instance(this);
    }
    /**
     * Generiert aus JSON-Daten (meist vom WEB-Server kommend), eine Instance
     * @param instance
     * @param virtualFields : default=undefined. In new applications virtualFields must NOT be used!!
     */
    static fromJSON(instance, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let instanceReturn = new Instance();
            let items = instance["items"];
            let catId = items["cgdocument.typeid"];
            if (!catId)
                throw new Error("cgdocument.typeid in instance is not set!");
            if (catId.value)
                throw new Error("Instance.fromJSON expects a plain JSON object. E.g. not a object of type Instance. Did you call Instance.fromJSON more than once?");
            let mapFieldDefs = yield FieldDef_1.FieldDef.getFieldDefsForCatId(catId, virtualFields);
            let bSearchExpression = false;
            if (instance["searchExpression"])
                bSearchExpression = instance["searchExpression"];
            if (instance["id"]) {
                instanceReturn.id.fieldDef = FieldDef_1.FieldDef.idFieldDef;
                instanceReturn.id.searchExpression = bSearchExpression;
                instanceReturn.id._valueInternal = instance["id"]; // Hier werden aus Performancegründen keine Typechecks gemacht
            }
            if (instance["name"]) {
                instanceReturn.name.fieldDef = FieldDef_1.FieldDef.nameFieldDef;
                instanceReturn.name.searchExpression = bSearchExpression;
                instanceReturn.name._valueInternal = instance["name"]; // Hier werden aus Performancegründen keine Typechecks gemacht
            }
            if (instance["icon"]) {
                instanceReturn.icon.fieldDef = FieldDef_1.FieldDef.iconFieldDef;
                instanceReturn.icon.searchExpression = bSearchExpression;
                instanceReturn.icon._valueInternal = instance["icon"]; // Hier werden aus Performancegründen keine Typechecks gemacht
            }
            if (instance["treename"]) {
                instanceReturn.treename.fieldDef = FieldDef_1.FieldDef.treenameFieldDef;
                instanceReturn.treename.searchExpression = bSearchExpression;
                instanceReturn.treename._valueInternal = instance["treename"]; // Hier werden aus Performancegründen keine Typechecks gemacht
            }
            if (instance["comment"]) {
                instanceReturn.comment.fieldDef = FieldDef_1.FieldDef.commentFieldDef;
                instanceReturn.comment.searchExpression = bSearchExpression;
                instanceReturn.comment._valueInternal = instance["comment"]; // Hier werden aus Performancegründen keine Typechecks gemacht
            }
            for (let instanceKey in items) {
                if (items.hasOwnProperty(instanceKey)) {
                    let value;
                    let item = items[instanceKey];
                    let fieldDef = mapFieldDefs[instanceKey];
                    if (!fieldDef) {
                        // Das ist ein Pseudofeld
                        if (bSearchExpression) {
                            // Da ist jedes Feld ein Stringfeld
                            fieldDef = FieldDef_1.FieldDef.NewStringFieldDef(instanceKey);
                        }
                        else {
                            // Anhand vom Feldinhalt bestimmen, von welchem Typ das Feld ist
                            // Nachdem leere Feldinhalte bzw. leere Multivalue-Felder nicht übertragen werden, ist auf alle Fälle mindestens ein konkreter Wert enthalten.
                            // Aus diesem Grund ist dieses Verfahren durchaus legitim.
                            if (Array.isArray(item)) {
                                if (item.length > 0) {
                                    let bDefaultStringType = true;
                                    for (let xValue = 0; xValue < item.length; xValue++) {
                                        let singleValue = item[xValue]; // anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                                        if (singleValue != undefined) {
                                            if (typeof singleValue === "string") {
                                                break;
                                            }
                                            else if (typeof singleValue === "number") {
                                                // Da wird DIGITVALUE angenommen. Wenn einmal ein FLOATVALUE bzw. BIGDIGITVALUE auch daherkommen sollte, dann muss das ganze bitte nicht über Instance transportiert werden,
                                                // sondern sauber über eine andere Datenstruktur.
                                                fieldDef = FieldDef_1.FieldDef.NewMultiValueDigitFieldDef(instanceKey);
                                                bDefaultStringType = false;
                                                break;
                                            }
                                            else if (singleValue instanceof Date) {
                                                // Da wird DATETIME angenommen. Wenn einmal ein DATEVALUE bzw. TIMEVALUE auch daherkommen sollte, dann muss das ganze bitte nicht über Instance transportiert werden,
                                                // sondern sauber über eine andere Datenstruktur.
                                                fieldDef = FieldDef_1.FieldDef.NewMultiValueDateTimeFieldDef(instanceKey);
                                                bDefaultStringType = false;
                                                break;
                                            }
                                            else if (typeof singleValue === "boolean") {
                                                fieldDef = FieldDef_1.FieldDef.NewMultiValueBoolFieldDef(instanceKey);
                                                bDefaultStringType = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (bDefaultStringType)
                                        fieldDef = FieldDef_1.FieldDef.NewMultiValueStringFieldDef(instanceKey);
                                }
                                else {
                                    // Leeres Array (das sollte eigentlich vom Server so nie zurückgegeben werden) --> Trotzdem mit einer vernünftigen Default-FieldDef versorgen.
                                    fieldDef = FieldDef_1.FieldDef.NewMultiValueStringFieldDef(instanceKey);
                                }
                            }
                            else {
                                let bDefaultStringType = true;
                                if (item != undefined) {
                                    if (typeof item === "string") {
                                    }
                                    else if (typeof item === "number") {
                                        // Da wird DIGITVALUE angenommen. Wenn einmal ein FLOATVALUE bzw. BIGDIGITVALUE auch daherkommen sollte, dann muss das ganze bitte nicht über Instance transportiert werden,
                                        // sondern sauber über eine andere Datenstruktur.
                                        fieldDef = FieldDef_1.FieldDef.NewDigitFieldDef(instanceKey);
                                        bDefaultStringType = false;
                                    }
                                    else if (item instanceof Date) {
                                        // Da wird DATETIME angenommen. Wenn einmal ein DATEVALUE bzw. TIMEVALUE auch daherkommen sollte, dann muss das ganze bitte nicht über Instance transportiert werden,
                                        // sondern sauber über eine andere Datenstruktur.
                                        fieldDef = FieldDef_1.FieldDef.NewDateTimeFieldDef(instanceKey);
                                        bDefaultStringType = false;
                                    }
                                    else if (typeof item === "boolean") {
                                        fieldDef = FieldDef_1.FieldDef.NewBoolFieldDef(instanceKey);
                                        bDefaultStringType = false;
                                    }
                                }
                                if (bDefaultStringType)
                                    fieldDef = FieldDef_1.FieldDef.NewStringFieldDef(instanceKey);
                            }
                        }
                    }
                    if (!bSearchExpression) {
                        // Values in search instances are treated as verbatim strings, as they can contain search expressions
                        // and thus are not parseable
                        let func;
                        switch (fieldDef.type) {
                            case Base_1.FieldType.Date:
                                func = Utilities_1.synUtil.jsonToDate;
                                break;
                            case Base_1.FieldType.Time:
                                func = Utilities_1.synUtil.jsonToTime;
                                break;
                            case Base_1.FieldType.DateTime:
                                func = Utilities_1.synUtil.jsonToDateTime;
                                break;
                        }
                        if (func) {
                            // Conversion of date,time,datetime and null --> undefined
                            if (fieldDef.multiValue) {
                                let convArr = [];
                                for (let xItem = 0; xItem < item.length; xItem++)
                                    convArr[xItem] = func(item[xItem]);
                                value = convArr;
                            }
                            else
                                value = func(item);
                        }
                        else {
                            // Conversion null --> undefined
                            // There is one known use case where null is in the JSON data: Multivalue fields.
                            // But the single value case is considered here too.
                            if (fieldDef.multiValue) {
                                for (let xItem = 0; xItem < item.length; xItem++) {
                                    // eslint-disable-next-line no-null/no-null
                                    if (item[xItem] === null)
                                        item[xItem] = undefined;
                                }
                                value = item;
                            }
                            else {
                                // eslint-disable-next-line no-null/no-null
                                if (item === null)
                                    value = undefined;
                                else
                                    value = item;
                            }
                        }
                    }
                    else
                        value = item;
                    // Hier werden aus Performancegründen keine Typechecks gemacht
                    instanceReturn.addFieldNoCheck(instanceKey, value, fieldDef, bSearchExpression);
                }
            }
            let itemsIncluded = instance["itemsIncluded"];
            if (itemsIncluded) {
                // Es wurden nicht alle Items vom Server angefordert --> somit ist die Instance nicht komplett!
                instanceReturn._itemsComplete = false;
                instanceReturn._itemsIncluded = itemsIncluded; // Hier genügt es derzeit die Referenz zu kopieren, da diese Daten nicht verändert werden (dürfen)
            }
            // Alle Values, die leer waren, werden vom Server nicht zurückgegeben --> Diese nun auffüllen
            if (instance["skipAddEmptyFields"] != true) {
                // Das Auffüllen wurde auch nicht "unterdrückt"
                if (itemsIncluded) {
                    // Es wurde nur ein bestimmtes Set an Feldern vom Server geholt. Alle Werte von diesen Feldern, die in der Instanz nicht vorhanden sind, sind somit als Leerwerte einzutragen
                    for (let key of itemsIncluded) {
                        if (!instanceReturn.items[key]) {
                            let fieldDef = mapFieldDefs[key];
                            if (fieldDef)
                                instanceReturn.addEmptyField(key, fieldDef, bSearchExpression);
                        }
                    }
                }
                else {
                    // Es wurden alle gefüllten Items vom Server übergeben --> Alle Felder der Kategorie, die in der Instanz nicht vorhanden sind, sind somit als Leerwerte einzutragen
                    for (let key in mapFieldDefs) {
                        if (!instanceReturn.items[key]) {
                            let fieldDef = mapFieldDefs[key];
                            instanceReturn.addEmptyField(key, fieldDef, bSearchExpression);
                        }
                    }
                }
            }
            let ftEntries = instance["ftEntries"];
            if (ftEntries != undefined) {
                // Infos zu den referenzierten FTEntries liegen vor
                instanceReturn._ftEntriesAvailable = true;
                let ftEntryInfoEmpty = new Instance.FTEntries();
                for (let key in instanceReturn.items) {
                    let item = instanceReturn.items[key];
                    if (item.fieldDef.isFTKeyField) {
                        let ftEntryInfo = ftEntryInfoEmpty;
                        let ftEntriesJSON = ftEntries[key];
                        if (ftEntriesJSON) {
                            // Da sind mal auf alle Fälle FTEntry-Infos vom Server zurückgegeben worden
                            ftEntryInfo = new Instance.FTEntries();
                            if (ftEntriesJSON["softDeletedEntries"])
                                ftEntryInfo.softDeletedEntries = ftEntriesJSON["softDeletedEntries"];
                            if (ftEntriesJSON["softDeletedWarningEntries"])
                                ftEntryInfo.softDeletedWarningEntries = ftEntriesJSON["softDeletedWarningEntries"];
                            if (ftEntriesJSON["hardDeletedEntries"])
                                ftEntryInfo.hardDeletedEntries = ftEntriesJSON["hardDeletedEntries"];
                            if (ftEntriesJSON["abstractEntries"])
                                ftEntryInfo.abstractEntries = ftEntriesJSON["abstractEntries"];
                        }
                        instanceReturn.ftEntries[key] = ftEntryInfo;
                        if (item.fieldDef.ftFields) {
                            for (let ftField of item.fieldDef.ftFields) {
                                if (instanceReturn.items[ftField.name]) {
                                    // FTField ist in der Instanz auch vorhanden
                                    instanceReturn.ftEntries[ftField.name] = ftEntryInfo;
                                }
                            }
                        }
                    }
                    else if (!item.fieldDef.isFTField) {
                        // Hinweis: die FTFields werden oben verarbeitet
                        instanceReturn.ftEntries[key] = ftEntryInfoEmpty;
                    }
                }
            }
            let contents = instance["contents"];
            if (contents != undefined) {
                // Content-Metadaten liegen vor
                instanceReturn._contentsAvailable = true;
                instanceReturn.contents = Content.fromJSONArray(contents);
            }
            return instanceReturn;
        });
    }
    /**
    *  Konvertiert eine Instance nach JSON
    */
    toJSON() {
        let instance = this;
        let convertedInstance = {};
        let searchExpression;
        let convertedItems = {};
        if (instance.id.value) {
            convertedInstance["id"] = instance.id.value;
        }
        if (instance.name.value) {
            convertedInstance["name"] = instance.name.value;
        }
        if (instance.icon.value) {
            convertedInstance["icon"] = instance.icon.value;
        }
        if (instance.treename.value) {
            convertedInstance["treename"] = instance.treename.value;
        }
        if (instance.comment.value) {
            convertedInstance["comment"] = instance.comment.value;
        }
        for (let instanceKey in instance.items) {
            let item = instance.items[instanceKey];
            if (searchExpression === undefined) {
                searchExpression = item.searchExpression;
            }
            let valueConverted;
            // Values in search instances are treated as verbatim strings, as they can contain search expressions
            // and thus are not parseable
            if (!searchExpression) {
                if (!item.isEmpty) {
                    let func;
                    switch (item.type) {
                        case Base_1.FieldType.Date:
                            func = Utilities_1.synUtil.dateToJson;
                            break;
                        case Base_1.FieldType.Time:
                            func = Utilities_1.synUtil.timeToJson;
                            break;
                        case Base_1.FieldType.DateTime:
                            func = Utilities_1.synUtil.dateTimeToJson;
                            break;
                    }
                    if (func) {
                        if (item.multiValue) {
                            let convArr = [];
                            for (let i = 0; i < item.valueAsDateArray.length; i++)
                                convArr[i] = func(item.valueAsDateArray[i]);
                            valueConverted = convArr;
                        }
                        else
                            valueConverted = func(item.value);
                    }
                    else
                        valueConverted = item.value;
                }
                else
                    // Auch hier werden keine Leerwerte mehr übertragen, da der Server diese dann auffüllt
                    continue;
            }
            else
                valueConverted = item.value;
            if (valueConverted === undefined)
                // Ein leerer Wert muss hier zu null konvertiert werden, ansonsten wird bei JSON.stringify der gesamte key rausgeworfen
                // eslint-disable-next-line no-null/no-null
                valueConverted = null;
            convertedItems[instanceKey] = valueConverted;
        }
        convertedInstance["items"] = convertedItems;
        if ((!instance._itemsComplete) && (instance._itemsIncluded)) {
            convertedInstance["itemsIncluded"] = [...instance._itemsIncluded];
        }
        if (instance._ftEntriesAvailable) {
            let convertedFtEntries = {};
            for (let key in instance.ftEntries) {
                let convertedFieldFtEntries = {};
                let ftEntryItem = instance.ftEntries[key];
                if (ftEntryItem.softDeletedEntries) {
                    convertedFieldFtEntries["softDeletedEntries"] = [...ftEntryItem.softDeletedEntries];
                }
                if (ftEntryItem.softDeletedWarningEntries) {
                    convertedFieldFtEntries["softDeletedWarningEntries"] = [...ftEntryItem.softDeletedWarningEntries];
                }
                if (ftEntryItem.hardDeletedEntries) {
                    convertedFieldFtEntries["hardDeletedEntries"] = [...ftEntryItem.hardDeletedEntries];
                }
                if (ftEntryItem.abstractEntries) {
                    convertedFieldFtEntries["abstractEntries"] = [...ftEntryItem.abstractEntries];
                }
                convertedFtEntries[key] = convertedFieldFtEntries;
            }
            convertedInstance["ftEntries"] = convertedFtEntries;
        }
        if (instance._contentsAvailable) {
            convertedInstance["contents"] = Content.toJSONArray(instance.contents);
        }
        if (searchExpression)
            convertedInstance["searchExpression"] = true;
        if (this.skipAddEmptyFields)
            convertedInstance["skipAddEmptyFields"] = true;
        return convertedInstance;
    }
    /**
    *  Konvertiert ein Instance array in ein JSON array
    */
    static toJSONArray(instances) {
        let convertedInstances = [];
        for (let instance of instances) {
            convertedInstances.push(instance.toJSON());
        }
        return convertedInstances;
    }
    /**
     * Generiert aus einem JSON-Array (meist vom WEB-Server kommend), ein Array von Instances
     * @param instancesJSON
     * @param virtualFields default=undefined. In new applications virtualFields must NOT be used!!
     */
    static fromJSONArray(instancesJSON, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let instancesReturn = [];
            for (let instanceJSON of instancesJSON) {
                instancesReturn.push(yield Instance.fromJSON(instanceJSON, virtualFields));
            }
            return instancesReturn;
        });
    }
    /**
    *  Generiert aus key-value-pairs eine Instance für die Suche. Beispiel:
    *      let searchInstance = await Instance.fromSearchData ({
    *          "cgdocument.typeid": "999999981",
    *          "cgexplorer.childs": "Y",
    *          "cgdocument.chkout": "Y",
    *          "cgdocument.doclock": "Y",
    *          "cgdocument.doclockby": "#variable.currentuser#"
    *         });
    *
    *      synUtil.getAJAXData({
    *           method: "POST",
    *           url: synUtil.getWSUrl("Search"),
    *           requestData: { query: JSON.stringify(searchInstance.toJSON()) },
    *           …
    */
    static fromSearchData(keyValues) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let instanceReturn = new Instance();
            let catId = keyValues["cgdocument.typeid"];
            if (!catId)
                throw new Error("cgdocument.typeid is required but is not set!");
            let mapFieldDefs = yield FieldDef_1.FieldDef.getFieldDefsForCatId(catId);
            for (let key in keyValues) {
                let fieldDef = mapFieldDefs[key];
                if (!fieldDef) {
                    // Das ist ein Pseudofeld
                    fieldDef = FieldDef_1.FieldDef.NewStringFieldDef(key);
                }
                instanceReturn.addField(key, keyValues[key], fieldDef, true);
            }
            return instanceReturn;
        });
    }
    /**
    *  Fügt ein zusätzliches search field hinzu.
    *  Die Instanz MUSS zuvor mit fromSearchData erstellt worden sein.
    */
    addSearchField(key, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let catIdItem = this.items["cgdocument.typeid"];
            if (!catIdItem)
                throw new Error("cgdocument.typeid is required but is not set! Please ensure that the instance is constructed with fromSearchData and includes cgdocument.typeid.");
            let catId = catIdItem.valueToString();
            let field = this.items[key];
            if (!field) {
                field = new Instance.Field();
                this.items[key] = field;
            }
            field.searchExpression = true;
            field.value = value;
            let mapFieldDefs = yield FieldDef_1.FieldDef.getFieldDefsForCatId(catId);
            let fieldDef = mapFieldDefs[key];
            if (!fieldDef) {
                // Das ist wohl ein Pseudofeld
                fieldDef = FieldDef_1.FieldDef.NewStringFieldDef(key);
            }
            field.fieldDef = fieldDef;
            return field;
        });
    }
    /**
    *  Leert den Inhalt eines Feldes aus.
    */
    clearField(key) {
        let field = this.items[key];
        if (field) {
            field.clear();
        }
    }
    /**
    *  Entfernt ein Feld.
    */
    removeField(key) {
        delete this.items[key];
    }
    /**
    *  =true: Instance enthält ein Feld mit diesem Namen.
    */
    hasField(key) {
        return (this.items[key] != undefined);
    }
    /**
    *  Sucht einen content von einem bestimmten Typ und gibt ihn - sofern vorhanden - zurück.
    *  Ob die contents vom Server geladen wurden, kann mittels des Properties contentsAvailable bestimmt werden.
    *  Sind die contents nicht geladen, wird eine Exception geworfen.
    */
    findContentType(contentType) {
        let contentReturn = undefined;
        if (!this._contentsAvailable)
            throw new Error("contents are not available. In the request set property fetchContents to true and ensure that the service implements fetching contents.");
        for (let content of this.contents) {
            if (content.items["cgcontent.contenttype"].valueAsNumber & contentType) {
                contentReturn = content;
                break;
            }
        }
        return contentReturn;
    }
}
exports.Instance = Instance;
(function (Instance) {
    class Field {
        // Methods
        constructor(init) {
            this._valueInternal = undefined;
            /**
            *  FiedDef des fields
            */
            this.fieldDef = FieldDef_1.FieldDef.nonameStringFieldDef;
            /**
            *  =true: value enthält eine search-Expression. In diesem Fall ist value immer vom Typ string.
            */
            this.searchExpression = false;
            if (init) {
                this.fieldDef = init.fieldDef;
                this.searchExpression = init.searchExpression;
                if (Array.isArray(init._valueInternal))
                    this._valueInternal = Object.assign([], init._valueInternal);
                else
                    this._valueInternal = init._valueInternal;
            }
        }
        static isEqualSingleValue(value1, value2, type) {
            let bReturn = false;
            if (value1 == undefined) {
                if (value2 != undefined)
                    bReturn = false;
                else
                    bReturn = true;
            }
            else if (value2 == undefined) {
                bReturn = false;
            }
            else {
                let ho, mo, so, mso, hc, mc, sc, yo, dyo, yc, dyc, mto, mtc, msc;
                switch (type) {
                    case Base_1.FieldType.Time:
                        {
                            let value2AsDate = value2;
                            let value1AsDate = value1;
                            ho = value1AsDate.getUTCHours();
                            mo = value1AsDate.getUTCMinutes();
                            so = value1AsDate.getUTCSeconds();
                            mso = value1AsDate.getUTCMilliseconds();
                            hc = value2AsDate.getUTCHours();
                            mc = value2AsDate.getUTCMinutes();
                            sc = value2AsDate.getUTCSeconds();
                            msc = value2AsDate.getUTCMilliseconds();
                            bReturn = (ho === hc && mo === mc && so === sc && mso === msc);
                            break;
                        }
                    case Base_1.FieldType.Date:
                        {
                            let value1AsDate = value1;
                            let value2AsDate = value2;
                            yo = value1AsDate.getUTCFullYear();
                            mo = value1AsDate.getUTCMonth();
                            dyo = value1AsDate.getUTCDate();
                            yc = value2AsDate.getUTCFullYear();
                            mc = value2AsDate.getUTCMonth();
                            dyc = value2AsDate.getUTCDate();
                            bReturn = (yo === yc && mo === mc && dyo === dyc);
                            break;
                        }
                    case Base_1.FieldType.DateTime:
                        {
                            let value1AsDate = value1;
                            let value2AsDate = value2;
                            yo = value1AsDate.getUTCFullYear();
                            mto = value1AsDate.getUTCMonth();
                            dyo = value1AsDate.getUTCDate();
                            yc = value2AsDate.getUTCFullYear();
                            mtc = value2AsDate.getUTCMonth();
                            dyc = value2AsDate.getUTCDate();
                            ho = value1AsDate.getUTCHours();
                            mo = value1AsDate.getUTCMinutes();
                            so = value1AsDate.getUTCSeconds();
                            mso = value1AsDate.getUTCMilliseconds();
                            hc = value2AsDate.getUTCHours();
                            mc = value2AsDate.getUTCMinutes();
                            sc = value2AsDate.getUTCSeconds();
                            msc = value2AsDate.getUTCMilliseconds();
                            bReturn = (yo === yc && mto === mtc && dyo === dyc && ho === hc && mo === mc && so === sc && mso === msc);
                            break;
                        }
                    default:
                        bReturn = value1 === value2;
                        break;
                }
            }
            return bReturn;
        }
        valueToNumberSingle(value, defaultValue) {
            if (typeof value === "number")
                return value;
            else if (typeof value === "string") {
                let numberReturn = Number(value);
                if (typeof numberReturn == "number")
                    return numberReturn;
                else
                    // could be NaN
                    return defaultValue;
            }
            else if (value instanceof Date) {
                let numberReturn = value;
                return numberReturn.getTime();
            }
            else
                return defaultValue;
        }
        valueToStringSingle(value) {
            if (typeof value === "string")
                return value;
            else if (typeof value === "number")
                return value.toString();
            else if (value instanceof Date)
                return value.toString();
            else
                return "";
        }
        // Properties
        /**
        *  key/name des fields.
        */
        get name() {
            return this.fieldDef.name;
        }
        /**
        *  value des fields.
        */
        get value() {
            return this._valueInternal;
        }
        /**
        *  value des fields.
        */
        set value(value) {
            if (this.searchExpression) {
                if (typeof value === "string")
                    this._valueInternal = value;
                else if (value == undefined) {
                    // An dieser Stelle wird Konsistenz für Leerwerte sichergestellt.
                    // Bei einer searchExpression ist der Leerwert per Definition immer ein leerer String. Das war auch in der "alten" Implementierung so.
                    this._valueInternal = "";
                }
                else
                    throw new TypeError("value in a searchexpression has to be of type string.");
            }
            else if (!Array.isArray(value)) {
                if (!this.fieldDef.multiValue) {
                    if ((value != undefined) && (value !== "")) {
                        // Kein Leerwert
                        switch (this.type) {
                            case Base_1.FieldType.String:
                            case Base_1.FieldType.FixString:
                                {
                                    if (typeof value !== "string")
                                        throw new TypeError("value has to be of type string.");
                                    break;
                                }
                            case Base_1.FieldType.Digit:
                            case Base_1.FieldType.Float:
                            case Base_1.FieldType.BigDigit:
                                {
                                    if (typeof value !== "number")
                                        throw new TypeError("value has to be of type number.");
                                    break;
                                }
                            case Base_1.FieldType.Date:
                            case Base_1.FieldType.Time:
                            case Base_1.FieldType.DateTime:
                                {
                                    if (!(value instanceof Date))
                                        throw new TypeError("value has to be of type Date.");
                                    break;
                                }
                            case Base_1.FieldType.Bool:
                                {
                                    if (typeof value !== "boolean")
                                        throw new TypeError("value has to be of type boolean.");
                                    break;
                                }
                            case Base_1.FieldType.FTKey:
                                {
                                    if ((typeof value !== "number") && (typeof value !== "string"))
                                        throw new TypeError("value has to be of type number or string.");
                                    break;
                                }
                            case Base_1.FieldType.Image:
                                {
                                    // Da ist jeder Datentyp zulässig
                                    break;
                                }
                            default:
                                {
                                    throw new TypeError("Unsupported datatype.");
                                }
                        }
                    }
                    else {
                        // An dieser Stelle wird Konsistenz für Leerwerte sichergestellt.
                        value = undefined;
                    }
                    this._valueInternal = value;
                }
                else
                    throw new TypeError("value has to be an array because the field is a multivalue field.");
            }
            else {
                if (this.fieldDef.multiValue) {
                    if (value.length > 0) {
                        for (let xValue = 0; xValue < value.length; xValue++) {
                            let singleValue = value[xValue]; // anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                            if (singleValue != undefined) {
                                switch (this.type) {
                                    case Base_1.FieldType.String:
                                    case Base_1.FieldType.FixString:
                                        {
                                            if (typeof singleValue !== "string")
                                                throw new TypeError("value has to be of type string.");
                                            break;
                                        }
                                    case Base_1.FieldType.Digit:
                                    case Base_1.FieldType.Float:
                                    case Base_1.FieldType.BigDigit:
                                        {
                                            if (typeof singleValue !== "number")
                                                throw new TypeError("value has to be of type number.");
                                            break;
                                        }
                                    case Base_1.FieldType.Date:
                                    case Base_1.FieldType.Time:
                                    case Base_1.FieldType.DateTime:
                                        {
                                            if (!(singleValue instanceof Date))
                                                throw new TypeError("value has to be of type Date.");
                                            break;
                                        }
                                    case Base_1.FieldType.Bool:
                                        {
                                            if (typeof singleValue !== "boolean")
                                                throw new TypeError("value has to be of type boolean.");
                                            break;
                                        }
                                    case Base_1.FieldType.FTKey:
                                        {
                                            if ((typeof singleValue !== "number") && (typeof singleValue !== "string"))
                                                throw new TypeError("value has to be of type number or string.");
                                            break;
                                        }
                                    case Base_1.FieldType.Image:
                                        {
                                            // Da ist jeder Datentyp zulässig
                                            break;
                                        }
                                    default:
                                        {
                                            throw new TypeError("Unsupported datatype.");
                                        }
                                }
                            }
                            else {
                                if (!this.fieldDef.isFTField)
                                    // Hinweis: undefined ist NUR bei FT-Feldern, die zu einem multivalue FTKey-Feld gehören, ein gültiger Wert
                                    throw new TypeError("undefined is not a valid value in a multivalue field.");
                            }
                        }
                    }
                    this._valueInternal = value;
                }
                else
                    throw new TypeError("The field is not multivalue. value must be a single value not an array.");
            }
        }
        /**
        *  Gibt value als string zurück.
        *  Ist value nicht vom Typ string, wird eine Exception geworfen.
        *  Ist value ein Array (=multivalue field), wird eine Exception geworfen.
        */
        get valueAsString() {
            if (typeof this._valueInternal === "string")
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // Hier wird die Konsistenz von Leerwerten sichergestellt
                return "";
            else
                throw new TypeError("value does not belong to a STRINGVALUE field.");
        }
        set valueAsString(value) {
            if (value)
                this.value = value;
            else
                // Hier wird die Konsistenz von Leerwerten sichergestellt
                this.value = undefined;
        }
        /**
        *  Gibt value als boolean zurück.
        *  Ist value nicht vom Typ boolean, wird eine Exception geworfen.
        */
        get valueAsBoolean() {
            if (typeof this._valueInternal === "boolean")
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // Damit sich die Anwendung nicht mit undefined herumschlagen muss
                return false;
            else
                throw new TypeError("value does not belong to a BOOLVALUE field.");
        }
        set valueAsBoolean(value) {
            if (value != undefined)
                // Hier wird auch false vermerkt - alles andere würde stören
                this.value = value;
            else
                // Hier wird sichergestellt, dass nur undefined verwendet wird und nicht null
                this.value = undefined;
        }
        /**
        *  Gibt value als number zurück.
        *  Ist value nicht vom Typ number, wird eine Exception geworfen.
        *  Ist value undefined, wird 0 zurückgegeben.
        *  Ist value ein Array (=multivalue field), wird eine Exception geworfen.
        */
        get valueAsNumber() {
            if (typeof this._valueInternal === "number")
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // Damit sich die Anwendung nicht mit undefined herumschlagen muss
                return 0;
            else
                throw new TypeError("value does not belong to a DIGITVALUE or FLOATVALUE field.");
        }
        set valueAsNumber(value) {
            if (value != undefined)
                this.value = value;
            else
                // Hier wird sichergestellt, dass nur undefined verwendet wird und nicht null
                this.value = undefined;
        }
        /**
        *  Gibt value als Date zurück.
        *  Ist value nicht vom Typ Date, wird eine Exception geworfen.
        *  Ist value undefined, wird undefined zurückgegeben.
        *  Ist value ein Array (=multivalue field), wird eine Exception geworfen.
        */
        get valueAsDate() {
            if (this._valueInternal instanceof Date)
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // undefined wird an dieser Stelle zugelassen, da es bei Date ansonsten keinen vernünftigen Default für "nicht gesetzt" gibt.
                return undefined;
            else
                throw new TypeError("value does not belong to a DATE, TIME or DATETIME field.");
        }
        set valueAsDate(value) {
            if (value != undefined)
                this.value = value;
            else
                // Hier wird sichergestellt, dass nur undefined verwendet wird und nicht null
                this.value = undefined;
        }
        /**
        *  Gibt value als Array zurück.
        *  Ist value kein Array (weil z.B. kein multivalue Field), wird eine Exception geworfen.
        */
        get valueAsArray() {
            if (this.valueIsArray) {
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a multivalue field.");
        }
        set valueAsArray(value) {
            this.value = value;
        }
        /**
        *  Gibt value als single value (KEIN Array) zurück.
        *  Ist value ein Array (weil multivalue Field), wird eine Exception geworfen.
        */
        get valueAsSingleValue() {
            if (!this.valueIsArray) {
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a single value field.");
        }
        set valueAsSingleValue(value) {
            this.value = value;
        }
        /**
        *  Gibt value als string Array zurück.
        *  Ist value kein string Array (weil z.B. kein multivalue Field oder dieses nicht vom Typ string[]), wird eine Exception geworfen.
        */
        get valueAsStringArray() {
            if (Array.isArray(this._valueInternal)) {
                // Hinweis zum folgenden Sourcecode: anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                if (this._valueInternal.length > 0) {
                    if (this.isFTField) {
                        for (let item of this._valueInternal) {
                            if (item != undefined) {
                                if (typeof this._valueInternal[0] !== "string") {
                                    throw new TypeError("value does not belong to a multivalue String, FixString, ... field.");
                                }
                                else
                                    // Sobald wir ein Element mit dem richtigen Datentyp gefunden haben, gehen wir davon aus, dass das in Ordnung geht.
                                    break;
                            }
                        }
                    }
                    else {
                        if (typeof this._valueInternal[0] !== "string") {
                            // Hier dürfen keine undefined values enthalten sein --> Sobald das erste Element den richtigen Datentyp hat, gehen wir davon aus, dass das in Ordnung geht.
                            throw new TypeError("value does not belong to a multivalue String, FixString, ... field.");
                        }
                    }
                }
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a multivalue field.");
        }
        set valueAsStringArray(value) {
            this.value = value;
        }
        /**
        *  Gibt value als Date Array zurück.
        *  Ist value kein Date Array (weil z.B. kein multivalue Field oder dieses nicht vom Typ Date[]), wird eine Exception geworfen.
        */
        get valueAsDateArray() {
            if (Array.isArray(this._valueInternal)) {
                // Hinweis zum folgenden Sourcecode: anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                if (this._valueInternal.length > 0) {
                    if (this.isFTField) {
                        for (let item of this._valueInternal) {
                            if (item != undefined) {
                                if (!(item instanceof Date)) {
                                    throw new TypeError("value does not belong to a multivalue Date, Time or DateTime field.");
                                }
                                else
                                    // Sobald wir ein Element mit dem richtigen Datentyp gefunden haben, gehen wir davon aus, dass das in Ordnung geht.
                                    break;
                            }
                        }
                    }
                    else {
                        if (!(this._valueInternal[0] instanceof Date)) {
                            // Hier dürfen keine undefined values enthalten sein --> Sobald das erste Element den richtigen Datentyp hat, gehen wir davon aus, dass das in Ordnung geht.
                            throw new TypeError("value does not belong to a multivalue Date, Time or DateTime field.");
                        }
                    }
                }
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a multivalue field.");
        }
        set valueAsDateArray(value) {
            this.value = value;
        }
        /**
        *  Gibt value als number Array zurück.
        *  Ist value kein number Array (weil z.B. kein multivalue Field oder dieses nicht vom Typ number[]), wird eine Exception geworfen.
        */
        get valueAsNumberArray() {
            if (Array.isArray(this._valueInternal)) {
                // Hinweis zum folgenden Sourcecode: anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                if (this._valueInternal.length > 0) {
                    if (this.isFTField) {
                        for (let item of this._valueInternal) {
                            if (item != undefined) {
                                if (typeof this._valueInternal[0] !== "number") {
                                    throw new TypeError("value does not belong to a multivalue Digit, Float, BigDigit, ... field.");
                                }
                                else
                                    // Sobald wir ein Element mit dem richtigen Datentyp gefunden haben, gehen wir davon aus, dass das in Ordnung geht.
                                    break;
                            }
                        }
                    }
                    else {
                        if (typeof this._valueInternal[0] !== "number") {
                            // Hier dürfen keine undefined values enthalten sein --> Sobald das erste Element den richtigen Datentyp hat, gehen wir davon aus, dass das in Ordnung geht.
                            throw new TypeError("value does not belong to a multivalue Digit, Float, BigDigit, ... field.");
                        }
                    }
                }
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a multivalue field.");
        }
        set valueAsNumberArray(value) {
            this.value = value;
        }
        /**
        *  Gibt value als boolean Array zurück.
        *  Ist value kein boolean Array (weil z.B. kein multivalue Field oder dieses nicht vom Typ boolean[]), wird eine Exception geworfen.
        *  Hinweis: ein boolean Array kann in syneris derzeit nur bei einem Multivalue-FT-Field vorkommen, wenn das FT-Field vom Typ BOOLVALUE ist
        */
        get valueAsBooleanArray() {
            if (Array.isArray(this._valueInternal)) {
                // Hinweis zum folgenden Sourcecode: anders geht die Typeüberprüfung bei Arrays in Typescript leider nicht.
                if (this._valueInternal.length > 0) {
                    if (this.isFTField) {
                        for (let item of this._valueInternal) {
                            if (item != undefined) {
                                if (typeof this._valueInternal[0] !== "boolean") {
                                    throw new TypeError("value does not belong to a multivalue FT-Field of type Boolean.");
                                }
                                else
                                    // Sobald wir ein Element mit dem richtigen Datentyp gefunden haben, gehen wir davon aus, dass das in Ordnung geht.
                                    break;
                            }
                        }
                    }
                    else {
                        // Ein "normales" Multivalue boolean field (ohne FT-Bezug) gibt es in syneris derzeit nicht.
                        throw new TypeError("value does not belong to a multivalue FT-Field of type Boolean.");
                    }
                }
                return this._valueInternal;
            }
            else
                throw new TypeError("value does not belong to a multivalue field.");
        }
        set valueAsBooleanArray(value) {
            this.value = value;
        }
        get valueIsArray() {
            return Array.isArray(this._valueInternal);
        }
        /**
        *  Konvertiert value zu number, ohne im Fehlerfall eine Exception zu werfen:
        *  - ist value ein number, wird dieser Wert zurückgegeben
        *  - ist value ein string, wird dieser String nach number konvertiert. Der String muss im aktuellen locale vorliegen.
        *  - ist value ein Date, wird die Anzahl der Millisekunden seit Jan 1, 1970, 00:00:00.000 GMT zurückgegeben
        *  - ist value ein array, so wird das erste item nach number konvertiert, sofern vorhanden.
        *  - In allen anderen Fällen wird defaultValue zurückgegeben
        */
        valueToNumber(defaultValue) {
            if (this.isEmpty)
                return defaultValue;
            else if (this.valueIsArray) {
                let valueAsArray = this.valueAsArray;
                if (valueAsArray.length >= 1) {
                    let singleValue = valueAsArray[0];
                    return this.valueToNumberSingle(singleValue, defaultValue);
                }
                else
                    return defaultValue;
            }
            else
                return this.valueToNumberSingle(this._valueInternal, defaultValue);
        }
        /**
        *  Konvertiert value zu string, ohne im Fehlerfall eine Exception zu werfen:
        *  - ist value ein string, wird dieser Wert zurückgegeben
        *  - ist value kein string, wird dieser value mittels toString() nach string konvertiert.
        *  - ist value ein array, so wird das erste item mittels toString() nach string konvertiert, sofern vorhanden.
        *  - In allen anderen Fällen wird ein leerer string zurückgegeben
        */
        valueToString() {
            if (this.isEmpty)
                return "";
            else if (this.valueIsArray) {
                let valueAsArray = this.valueAsArray;
                if (valueAsArray.length >= 1) {
                    let singleValue = valueAsArray[0];
                    return this.valueToStringSingle(singleValue);
                }
                else
                    return "";
            }
            else
                return this.valueToStringSingle(this._valueInternal);
        }
        /**
        *  type des fields
        */
        get type() {
            return this.fieldDef.type;
        }
        /**
        *  =true: field ist ein FT-Field, jedoch kein FTKey-Field
        */
        get isFTField() {
            return this.fieldDef.isFTField;
        }
        /**
        *  =true: field ist ein Multivalue-Field. Hinwei: Ist "treated as singlevalue" auf true gesetzt, liefert multivalue=false
        */
        get multiValue() {
            return this.fieldDef.multiValue;
        }
        /**
        *  Nimmt ein deep copy des fields vor.
        */
        clone() {
            return new Field(this);
        }
        /**
        *  Leert das field aus.
        */
        clear() {
            if (this.searchExpression) {
                // Bei einer searchExpression ist der Leerwert per Definition immer ein leerer String. Das war auch in der "alten" Implementierung so.
                this._valueInternal = "";
            }
            else {
                if (this.fieldDef.multiValue) {
                    this._valueInternal = [];
                }
                else {
                    this._valueInternal = undefined;
                }
            }
        }
        /**
        *  =true: Inhalt des fields ist leer.
        */
        get isEmpty() {
            let breturn = true;
            if (this.searchExpression) {
                breturn = (this._valueInternal == undefined) || (this._valueInternal === "");
            }
            else {
                if (Array.isArray(this._valueInternal))
                    breturn = this._valueInternal.length === 0;
                else {
                    breturn = (this._valueInternal == undefined) || (this._valueInternal === ""); // einen leeren String interpretieren wir natürlich auch als Leerwert
                }
            }
            return breturn;
        }
        /**
        *  =true: der Inhalt der beiden fields ist ident. Der name der beiden fields wird nicht verglichen.
        */
        isEqual(field) {
            let bReturn = false;
            if (field != undefined) {
                if (field.searchExpression) {
                    bReturn = field._valueInternal === this._valueInternal;
                }
                else {
                    if ((!Array.isArray(field._valueInternal)) && (!Array.isArray(this._valueInternal))) {
                        bReturn = Field.isEqualSingleValue(field._valueInternal, this._valueInternal, field.type);
                    }
                    else if ((Array.isArray(field._valueInternal)) && (Array.isArray(this._valueInternal))) {
                        let value1 = this.valueAsArray;
                        let value2 = field.valueAsArray;
                        if (value1.length !== value2.length) {
                            bReturn = false;
                        }
                        else {
                            bReturn = true;
                            for (let xValue = 0; xValue < value1.length; xValue++) {
                                if (!Field.isEqualSingleValue(value1[xValue], value2[xValue], field.type)) {
                                    bReturn = false;
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        bReturn = false;
                    }
                }
            }
            return bReturn;
        }
    }
    Instance.Field = Field;
    ;
    class FTEntries {
        constructor() {
            // Properties
            this.hardDeletedEntries = undefined;
            this.softDeletedEntries = undefined;
            this.softDeletedWarningEntries = undefined;
            this.abstractEntries = undefined;
            // Methods
        }
        get hardDeleted() {
            return (this.hardDeletedEntries != undefined) && (this.hardDeletedEntries.length > 0);
        }
        ;
        get softDeleted() {
            return (this.softDeletedEntries != undefined) && (this.softDeletedEntries.length > 0);
        }
        ;
        get showSoftDeletedWarning() {
            return (this.softDeletedWarningEntries != undefined) && (this.softDeletedWarningEntries.length > 0);
        }
        ;
        get isAbstract() {
            return (this.abstractEntries != undefined) && (this.abstractEntries.length > 0);
        }
        ;
    }
    Instance.FTEntries = FTEntries;
})(Instance = exports.Instance || (exports.Instance = {}));
class Content extends kendo.data.ObservableObject {
    // Methods
    constructor(content) {
        super();
        // Properties
        /**
        *  Metadaten des Content
        */
        this.items = {};
        if (content) {
            for (let key in content.items) {
                this.items[key] = new Content.Field(content.items[key]);
            }
        }
    }
    addFieldNoCheck(key, value) {
        let field = this.items[key];
        if (!field) {
            field = new Content.Field();
            this.items[key] = field;
        }
        field._valueInternal = value; // Hier wird auf private Member zugegriffen, um die Typechecks zu umgehen.
        return field;
    }
    addEmptyField(key) {
        let field = this.items[key];
        if (!field) {
            field = new Content.Field();
            this.items[key] = field;
        }
        field.clear();
        return field;
    }
    get conid() {
        return this.items["cgcontent.conid"];
    }
    get createby() {
        return this.items["cgcontent.createby"];
    }
    get createdate() {
        return this.items["cgcontent.createdate"];
    }
    get lastchangeby() {
        return this.items["cgcontent.lastchangeby"];
    }
    get lastchangedate() {
        return this.items["cgcontent.lastchangedate"];
    }
    get contentname() {
        return this.items["cgcontent.contentname"];
    }
    get contentext() {
        return this.items["cgcontent.contentext"];
    }
    get contenttype() {
        return this.items["cgcontent.contenttype"];
    }
    get filetype() {
        return this.items["cgcontent.filetype"];
    }
    get filesize() {
        return this.items["cgcontent.filesize"];
    }
    get filetypeversion() {
        return this.items["cgcontent.filetypeversion"];
    }
    get cemimetype() {
        return this.items["cgcontent.cemimetype"];
    }
    get pagesize() {
        return this.items["cgcontent.pagesize"];
    }
    get longitude() {
        return this.items["cgcontent.longitude"];
    }
    get latitude() {
        return this.items["cgcontent.latitude"];
    }
    get pagecount() {
        return this.items["cgcontent.pagecount"];
    }
    /**
    *  Nimmt ein deepcopy des Contents vor
    */
    clone() {
        return new Content(this);
    }
    static fromJSON(content) {
        let contentReturn = new Content();
        let items = content["items"];
        for (let contentKey in items) {
            if (items.hasOwnProperty(contentKey)) {
                let value;
                let item = items[contentKey];
                if (item != undefined) {
                    switch (contentKey) {
                        case "cgcontent.createdate":
                        case "cgcontent.lastchangedate":
                            value = Utilities_1.synUtil.jsonToDateTime(item);
                            break;
                        default:
                            value = item;
                            break;
                    }
                }
                else {
                    value = item;
                }
                // Hier werden aus Performancegründen keine Typechecks gemacht
                contentReturn.addFieldNoCheck(contentKey, value);
            }
        }
        // Nicht enthaltene Felder sind leer
        for (let key of this._fieldNames) {
            if (!contentReturn.items[key]) {
                contentReturn.addEmptyField(key);
            }
        }
        return contentReturn;
    }
    /**
    *  Generiert aus einem JSON-Array (meist vom WEB-Server kommend), ein Array von Contents
    */
    static fromJSONArray(contentsJSON) {
        let contentsReturn = [];
        for (let contentJSON of contentsJSON) {
            contentsReturn.push(Content.fromJSON(contentJSON));
        }
        return contentsReturn;
    }
    /**
    *  Konvertiert einen Content nach JSON
    */
    toJSON() {
        let content = this;
        let convertedContent = {};
        let convertedContentItems = {};
        let valueConverted;
        for (let contentKey in content.items) {
            let item = content.items[contentKey];
            if (!item.isEmpty) {
                switch (contentKey) {
                    case "cgcontent.createdate":
                    case "cgcontent.lastchangedate":
                        valueConverted = Utilities_1.synUtil.dateTimeToJson(item.value);
                        break;
                    default:
                        valueConverted = item.value;
                        break;
                }
                if (valueConverted === undefined)
                    // Ein leerer Wert muss hier zu null konvertiert werden, ansonsten wird bei JSON.stringify der gesamte key rausgeworfen
                    // eslint-disable-next-line no-null/no-null
                    valueConverted = null;
                convertedContentItems[contentKey] = valueConverted;
            }
        }
        convertedContent["items"] = convertedContentItems;
        return convertedContent;
    }
    /**
    *  Konvertiert ein Content array in ein JSON array
    */
    static toJSONArray(contents) {
        let convertedContents = [];
        for (let content of contents) {
            convertedContents.push(content.toJSON());
        }
        return convertedContents;
    }
}
exports.Content = Content;
Content._fieldNames = [
    "cgcontent.conid",
    "cgcontent.createby",
    "cgcontent.createdate",
    "cgcontent.lastchangeby",
    "cgcontent.lastchangedate",
    "cgcontent.contentname",
    "cgcontent.contentext",
    "cgcontent.contenttype",
    "cgcontent.filetype",
    "cgcontent.filesize",
    "cgcontent.filetypeversion",
    "cgcontent.cemimetype",
    "cgcontent.pagesize",
    "cgcontent.longitude",
    "cgcontent.latitude",
    "cgcontent.pagecount"
];
(function (Content) {
    class Field {
        // Methods
        constructor(field) {
            this._valueInternal = undefined;
            if (field) {
                this._valueInternal = field._valueInternal;
            }
        }
        // Properties
        /**
        *  value des fields.
        */
        get value() {
            return this._valueInternal;
        }
        /**
        *  Gibt value als string zurück.
        *  Ist value nicht vom Typ string, wird eine Exception geworfen.
        */
        get valueAsString() {
            if (typeof this._valueInternal === "string")
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // Hier wird die Konsistenz von Leerwerten sichergestellt
                return "";
            else
                throw new TypeError("value does not belong to a string field.");
        }
        /**
        *  Gibt value als number zurück.
        *  Ist value nicht vom Typ number, wird eine Exception geworfen.
        *  Ist value undefined, wird 0 zurückgegeben.
        *  Ist value ein Array (=multivalue field), wird eine Exception geworfen.
        */
        get valueAsNumber() {
            if (typeof this._valueInternal === "number")
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // Damit sich die Anwendung nicht mit undefined herumschlagen muss
                return 0;
            else
                throw new TypeError("value does not belong to a number field.");
        }
        /**
        *  Gibt value als Date zurück.
        *  Ist value nicht vom Typ Date oder undefined, wird eine Exception geworfen.
        *  Ist value undefined, wird undefined zurückgegeben.
        */
        get valueAsDate() {
            if (this._valueInternal instanceof Date)
                return this._valueInternal;
            else if (this._valueInternal == undefined)
                // undefined wird an dieser Stelle zugelassen, da es bei Date ansonsten keinen vernünftigen Default für "nicht gesetzt" gibt.
                return undefined;
            else
                throw new TypeError("value does not belong to a Date field.");
        }
        /**
        *  =true: Inhalt des fields ist leer.
        */
        get isEmpty() {
            let breturn = true;
            breturn = (this._valueInternal == undefined) || (this._valueInternal === ""); // einen leeren String interpretieren wir natürlich auch als Leerwert
            return breturn;
        }
        /**
        *  Konvertiert value zu string, ohne im Fehlerfall eine Exception zu werfen:
        *  - ist value ein string, wird dieser Wert zurückgegeben
        *  - ist value kein string, wird dieser value mittels toString() nach string konvertiert.
        *  - In allen anderen Fällen wird ein leerer string zurückgegeben
        */
        valueToString() {
            if (this.isEmpty)
                return "";
            else if (typeof this._valueInternal === "string")
                return this._valueInternal;
            else if (typeof this._valueInternal === "number")
                return this._valueInternal.toString();
            else if (this._valueInternal instanceof Date)
                return this._valueInternal.toString();
            else
                return "";
        }
        /**
        *  Konvertiert value zu number, ohne im Fehlerfall eine Exception zu werfen:
        *  - ist value ein number, wird dieser Wert zurückgegeben
        *  - ist value ein string, wird dieser String nach number konvertiert. Der String muss im aktuellen locale vorliegen.
        *  - ist value ein Date, wird die Anzahl der Millisekunden seit Jan 1, 1970, 00:00:00.000 GMT zurückgegeben
        *  - In allen anderen Fällen wird defaultValue zurückgegeben
        */
        valueToNumber(defaultValue) {
            if (this.isEmpty)
                return defaultValue;
            else if (typeof this._valueInternal === "number")
                return this._valueInternal;
            else if (typeof this._valueInternal === "string") {
                let numberReturn = Number(this._valueInternal);
                if (typeof numberReturn == "number")
                    return numberReturn;
                else
                    // could be NaN
                    return defaultValue;
            }
            else if (this._valueInternal instanceof Date) {
                let numberReturn = this._valueInternal;
                return numberReturn.getTime();
            }
            else
                return defaultValue;
        }
        /**
        *  Leert den Inhalt aus.
        */
        clear() {
            this._valueInternal = undefined;
        }
    }
    Content.Field = Field;
})(Content = exports.Content || (exports.Content = {}));
